import { createTheme } from '@mui/material/styles';

export const altelTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#E73389',
      mainRGB: '231, 159, 184'
    },
    secondary: {
      main: '#E79FB8',
    },
  },
});
